/* eslint-disable no-undef */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faSpinner } from '@fortawesome/free-solid-svg-icons';
import React, { useCallback, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Button, OverlayTrigger, Table, Tooltip } from 'react-bootstrap';
import { ApplicationQuestionnaireList } from '../api/openapi';
import { questionnaireApi } from '../api';

const Questionnaires = (): React.ReactElement => {
  const { t } = useTranslation(['applicationquestionnaires', 'common']);
  const [data, setData] = useState<ApplicationQuestionnaireList[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const getApplicationQuestionnaire = useCallback(async () => {
    setLoading(true);

    try {
      const response = await questionnaireApi.applicationQuestionnaireList();

      setData(response.data);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getApplicationQuestionnaire();
  }, [getApplicationQuestionnaire]);

  if (error) {
    return <>{t('common:kerfisvilla')}</>;
  }

  if (loading || data == null) {
    return (
      <>
        <FontAwesomeIcon spin icon={faSpinner} />
      </>
    );
  }

  return (
    <>
      <div>
        {' '}
        {data.length === 0 ? (
          <div>{t('common:noDataFound')}</div>
        ) : (
          <Table striped bordered hover className="mt-5">
            <thead>
              <tr>
                <th>{t('industry')}</th>
                <th>{t('school')}</th>
                <th>{t('')}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((applicationQuestionnaire) => (
                <tr key={applicationQuestionnaire.id}>
                  <td>{applicationQuestionnaire.application.industry.name}</td>
                  <td>{applicationQuestionnaire.application.school.name}</td>
                  <td>
                    <OverlayTrigger placement="right-end" overlay={<Tooltip id="tooltip-other">{t('editQuestionnaire')}</Tooltip>}>
                      <Button type="button" variant="link" href={`/matslisti/${applicationQuestionnaire.id}`} className="btn-edit">
                        <FontAwesomeIcon icon={faPen} />
                      </Button>
                    </OverlayTrigger>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </div>
    </>
  );
};

export default Questionnaires;
